// import React, { useState, useEffect, useContext } from "react";
// import {
// Navbar, Nav, Container, Row, Col, Card, Button,
// ListGroup, Form, Dropdown, Spinner, Modal, Offcanvas
// } from "react-bootstrap";
// import { GrCart } from "react-icons/gr";
// import { RxCross1, RxHamburgerMenu } from "react-icons/rx";
// import { Link, useNavigate } from "react-router-dom";
// import axios from "axios";
// import "../style/admin.css";
// import { CartContext } from './CartContext';

// const SlideBar = () => {
// const [cart, setCart] = useState([]);
// const [sidebarOpen, setSidebarOpen] = useState(false);
// const [displayData, setDisplayData] = useState([]);
// const [itemCode, setItemCode] = useState("");
// const [loading, setLoading] = useState(false);
// const [allData, setAllData] = useState([]);
// const [selectedItem, setSelectedItem] = useState("Products");
// const [show, setShow] = useState(false);
// const [showSidebar, setShowSidebar] = useState(false);
// const [brandLogo, setBrandLogo] = useState(null);
// const [AllSizes, setAllSizes] = useState([]);
// const [isLoading, setIsLoading] = useState(false);
// const [apiData, setApiData] = useState(null);
// const [error, setError] = useState(null);
// const [count, setcount] = useState(0);
// const [logo, setLogo] = useState(null);
// const [name, setName] = useState("");
// const [customerName, setCustomerName] = useState("");
// const [sizes, setSizes] = useState([]);
// const [selectProduct, setSelectProduct] = useState(false);
// const Token = localStorage.getItem("token");
// const navigate = useNavigate();
// const { cartCount, cartItems, setCartItems } = useContext(CartContext);

// const [filters, setFilters] = useState({
// gross_weight_min: "",
// gross_weight_max: "",
// net_weight_min: "",
// net_weight_max: "",
// stone_weight_min: "",
// stone_weight_max: "",
// size_min: "",
// size_max: "",
// });

// // Restore filters, selections, and display data
// // useEffect(() => {
// // const storedFilters = localStorage.getItem("filters");
// // const storedSelectedItem = localStorage.getItem("selectedItem");
// // const storedAllSizes = localStorage.getItem("allSizes");
// // const storedDisplayData = localStorage.getItem("displayData");
// // const storedSelectProduct = localStorage.getItem("selectProduct");

// // if (storedFilters) setFilters(JSON.parse(storedFilters));
// // if (storedSelectedItem) setSelectedItem(JSON.parse(storedSelectedItem));
// // if (storedAllSizes) setAllSizes(JSON.parse(storedAllSizes));
// // if (storedDisplayData) setDisplayData(JSON.parse(storedDisplayData));
// // if (storedSelectProduct) setSelectProduct(JSON.parse(storedSelectProduct));
// // }, []);

// // // Persist filters and selections
// // useEffect(() => {
// // localStorage.setItem("filters", JSON.stringify(filters));
// // localStorage.setItem("selectedItem", JSON.stringify(selectedItem));
// // localStorage.setItem("allSizes", JSON.stringify(AllSizes));
// // localStorage.setItem("displayData", JSON.stringify(displayData));
// // localStorage.setItem("selectProduct", JSON.stringify(selectProduct));
// // }, [filters, selectedItem, AllSizes, displayData, selectProduct]);

// useEffect(() => {
//   const storedFilters = localStorage.getItem("filters");
//   const storedSelectedItem = localStorage.getItem("selectedItem");
//   const storedAllSizes = localStorage.getItem("allSizes");
//   const storedDisplayData = localStorage.getItem("displayData");
//   const storedSelectProduct = localStorage.getItem("selectProduct");

//   if (storedFilters) setFilters(JSON.parse(storedFilters));
//   if (storedSelectedItem) setSelectedItem(JSON.parse(storedSelectedItem));
//   if (storedAllSizes) setAllSizes(JSON.parse(storedAllSizes));
//   if (storedDisplayData) setDisplayData(JSON.parse(storedDisplayData));
//   if (storedSelectProduct) setSelectProduct(JSON.parse(storedSelectProduct));
// }, []);

// useEffect(() => {
//   localStorage.setItem("filters", JSON.stringify(filters));
//   localStorage.setItem("selectedItem", JSON.stringify(selectedItem));
//   localStorage.setItem("allSizes", JSON.stringify(AllSizes));
//   localStorage.setItem("displayData", JSON.stringify(displayData));
//   localStorage.setItem("selectProduct", JSON.stringify(selectProduct));
// }, [filters, selectedItem, AllSizes, displayData, selectProduct]);

// const handleSidebarClose = () => setShowSidebar(false);
// const handleSidebarShow = () => setShowSidebar(true);

// const handleCheckBoxChange = (event) => {
// const { name, checked, value } = event.target;
// if (name === "size") {
// setAllSizes(checked ? [value] : AllSizes.filter((size) => size !== value));
// }
// };

// const handleInputChange = (e) => {
// const { name, value } = e.target;
// setFilters((prevFilters) => ({ ...prevFilters, [name]: value }));
// };

// const applyFilters = async () => {
// const queryParams = new URLSearchParams();
// if (AllSizes.length > 0) {
// queryParams.append("size", AllSizes.join(","));
// }
// Object.entries(filters).forEach(([key, value]) => {
// if (value !== "") {
// queryParams.append(key, value);
// }
// });
// try {
// const response = await fetch(
// `${apibasePath}/client/customer-item-stock-list/?${queryParams.toString()}`,
// {
// method: 'GET',
// headers: {
// Authorization: `bearer ${Token}`,
// 'Content-Type': 'application/json',
// },
// }
// );
// const data = await response.json();
// setDisplayData(data);
// } catch (error) {
// console.error("Error while fetching data", error);
// }
// };
// // const { cartItems, setCartItems } = useContext(CartContext);
// const API_URL = "${apibasePath}/client/cart/add/";
//     const handleAddToCart = async (product) => {
//         const Token = localStorage.getItem("token");
//         try {
//             const response = await axios.post(API_URL, product, {
//                 headers: {
//                     Authorization: `bearer ${Token}`,
//                     "Content-Type": "application/json",
//                 },
//             });

//             const newCart = [...cartItems, product.item_tag];
//             setCartItems(newCart);
//             console.log("button cart list", cartItems);
//             setLoading(false)
//         } catch (error) {
//             console.error("Error adding to cart", error);
//             if (error.response?.status === 400) {
//                 if (!cartItems.includes(product.item_tag)) {
//                     setCartItems([...cartItems, product.item_tag]);
//                 }
//             } else {
//                 alert("An error occurred while adding to cart.");
//             }
//         }
//     };

//     const handleClick = (item) => {
//       // if (item === "Products") {
//       //     handleAllitem();
//       // } else {
//       // fetchItemData(item);
//       // }
//       fetchItemData(item);
//       setSelectedItem(item === "Products" ? "Products" : item.item_name);
//   };

//    const fetchItemData = async (item) => {
//           const Token = localStorage.getItem("token");

//           setItemCode(item.item_code);

//           try {
//               // setLoading(true);
//               const res = await axios.get(
//                   `${apibasePath}/client/customer-item-stock/${item.item_code}/`,
//                   {
//                       headers: {
//                           Authorization: `bearer ${Token}`,
//                           "Content-Type": "application/json",
//                       },
//                   }
//               );

//               setDisplayData(res?.data);
//               setSelectProduct(true)
//               // setLoading(false);
//           } catch (error) {
//               console.error("Error while getting data", error);
//               // setLoading(false);
//           }
//       };

//       const Api_Url = "${apibasePath}/client/customer-items/";

//         const [itemData, setItemData] = useState([]);

//           const fetchData = async () => {
//               const Token = localStorage.getItem("token");
//               try {
//                   setLoading(true)
//                   const res = await axios.get(Api_Url, {
//                       headers: {
//                           Authorization: `bearer ${Token}`,
//                       },
//                   });
//                   setItemData(res.data);
//                   setLoading(false)
//               } catch (error) {
//                   console.error("error", error);
//               }
//           };
//         useEffect(()=>{
//           fetchData();
//         },[])

//          const sizeApi = "${apibasePath}/client/available-sizes/";

//             useEffect(() => {
//                 const fetchSizeData = async () => {
//                     try {
//                         const response = await axios.get(sizeApi, {
//                             headers: {
//                                 Authorization: `bearer ${Token}`,
//                                 "Content-Type": 'application/json'
//                             }
//                         });
//                         console.log(response);
//                         setSizes(response.data); // Assuming response.data is an array of size values
//                     } catch (error) {
//                         console.error("Error fetching sizes:", error);
//                     }
//                 };

//                 fetchSizeData();
//             }, []);

//         const [selectedData, setSelectedData] = useState([]);

//             // const clearFilters = () => {
//             //   const cleared = {
//             //     gross_weight_min: "",
//             //     gross_weight_max: "",
//             //     net_weight_min: "",
//             //     net_weight_max: "",
//             //     stone_weight_min: "",
//             //     stone_weight_max: "",
//             //     size: ""
//             //   };

//             //   // 1. Reset filter state
//             //   setFilters(cleared);

//             //   // 2. Reset all sizes
//             //   setAllSizes([]);

//             //   // 3. Remove from localStorage
//             //   localStorage.removeItem('selectedSizes');
//             //   Object.keys(cleared).forEach(key => {
//             //     localStorage.removeItem(key);
//             //   });

//             //   // 4. Reset any selected data (if you have it in state)
//             //   setSelectedData([]); // <-- Make sure you have this state for selected items

//             //   // 5. Optionally reset checkboxes (if needed)
//             //   document.querySelectorAll('input[type=checkbox]').forEach(el => el.checked = false);

//             //   // 6. Show all items again
//             //   handleAllitem();
//             // };

//             const clearFilters = () => {
//               const cleared = {
//                 gross_weight_min: "",
//                 gross_weight_max: "",
//                 net_weight_min: "",
//                 net_weight_max: "",
//                 stone_weight_min: "",
//                 stone_weight_max: "",
//                 size: ""
//               };

//               // 1. Reset states
//               setFilters(cleared);
//               setAllSizes([]);
//               setSelectedItem([]);
//               setDisplayData([]);
//               setSelectProduct([]);
//               setSelectedData && setSelectedData([]); // optional safeguard

//               // 2. Persist cleared data to localStorage (important!)
//               localStorage.setItem("filters", JSON.stringify(cleared));
//               localStorage.setItem("selectedItem", JSON.stringify([]));
//               localStorage.setItem("allSizes", JSON.stringify([]));
//               localStorage.setItem("displayData", JSON.stringify([]));
//               localStorage.setItem("selectProduct", JSON.stringify([]));
//               localStorage.removeItem("selectedSizes"); // optional

//               // 3. Clear checkboxes if needed
//               document.querySelectorAll('input[type=checkbox]').forEach(el => el.checked = false);

//               // 4. Show all items again
//               // handleAllitem();
//             };

//           const All_Api = "${apibasePath}/client/customer-item-stock-list/";
//           const handleAllitem = async () => {
//                   // const Token = localStorage.getItem("token");
//                   <h1>Select Product</h1>
//                   try {
//                       setLoading(true)
//                       const res = await axios.get(All_Api, {
//                           headers: {
//                               Authorization: `bearer ${Token}`,
//                               "Content-Type": "application/json",
//                           },
//                       });
//                       setSelectedItem("Products");
//                       setDisplayData(res.data);
//                       setLoading(false)
//                   } catch (error) {
//                       console.error(error);
//                   }
//               };

// return (
//  <div className="slide">

//             <Navbar className="bg-body-tertiary fixed-top" expand="md">
//                 <Container fluid>
//                     <Navbar.Brand>
//                         <div style={{ width: "100px", height: '50px', borderRadius: '10px', overflow: 'hidden' }}>
//                             <img src={logo} alt="companylogo" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
//                         </div>
//                     </Navbar.Brand>
//                     <Navbar.Brand style={{ color: '#23395B', fontFamily: 'Roboto', fontWeight: '600', marginRight: 'auto', fontSize: '17px' }}>
//                         {name}
//                     </Navbar.Brand>
//                     <Navbar.Brand style={{ color: '#23395B', fontFamily: 'Roboto', fontWeight: '600', marginRight: 'auto', fontSize: '17px' }}>
//                         {customerName}'s Shopping Cart
//                     </Navbar.Brand>
//                     <div className="d-flex align-items-center">
//                         <Button variant="outline-light" className="d-md-none" onClick={handleSidebarShow}>
//                             <RxHamburgerMenu style={{ width: '30px', height: '30px', cursor: 'pointer', color: '#000' }} />
//                         </Button>
//                         <Navbar.Brand className="cart">
//                             {/* <a href="/add-to-cartdetails">
//                                 <GrCart style={{ width: '30px', height: '30px', color: '#396D72' }} />
//                             </a> */}
//                             <a href="/add-to-cartdetails" style={{ position: 'relative' }}>
//                                 <GrCart style={{ width: '30px', height: '30px', color: '#396D72' }} />
//                                 {cartCount > 0 && (
//                                     <span style={{
//                                         position: 'absolute',
//                                         top: '-5px',
//                                         right: '-5px',
//                                         backgroundColor: 'red',
//                                         color: 'white',
//                                         borderRadius: '50%',
//                                         padding: '4px 7px',
//                                         fontSize: '12px',
//                                     }}>
//                                         {cartCount}
//                                     </span>
//                                 )}
//                             </a>
//                         </Navbar.Brand>
//                     </div>
//                 </Container>
//             </Navbar>

//             <Container fluid    >
//                 <Row>
//                     {/* Sidebar - Always visible on larger screens, collapsible on mobile */}

//                     <Col md={3} className="p-3 d-none d-md-block fixed-sidebar " style={{ backgroundColor: "#396D72", height: '130vh', marginTop: '70px' }}>
//                         {/* <h5 className="text-white">Jewellery Items</h5> */}
//                         <Dropdown>
//                             <Dropdown.Toggle variant="" style={{ color: '#fff', border: 'none', fontSize: '20px', fontfamily: 'Roboto', fontWeight: '500', lineHeight: '1.2', letterSpacing: '0', marginLeft: '22px' }}>{selectedItem}</Dropdown.Toggle>
//                             <Dropdown.Menu style={{ backgroundImage: "linear-gradient(to bottom left,#C7E0E3, #FFFFFF ) " }}>
//                                 {/* <Dropdown.Item  key="all" >Products</Dropdown.Item> */}
//                                 {itemData.map((item, index) => (
//                                     <Dropdown.Item key={index} onClick={() => handleClick(item)} >{item.item_name}</Dropdown.Item>
//                                 ))}
//                             </Dropdown.Menu>
//                         </Dropdown>

//                         {/* filters */}

//                         <div>
//                             <Form style={{ paddingTop: '20px', marginLeft: '30px' }}>
//                                 {/* <Form.Label style={{ color: '#fff', fontSize: '30px', fontFamily: 'Poppins', textDecoration: "underline" }}>Apply Filters</Form.Label> */}
//                                 <Form.Group >
//                                     <Form.Label style={{ color: '#fff', fontfamily: 'Roboto', fontWeight: '500', lineHeight: '1.2', letterSpacing: '0', fontSize: '20px' }}>Size</Form.Label> <br />
//                                     <div className="checks" style={{ display: "flex", color: "#fff", justifyContent: "space-between", backgroundColor: "transparent" }}>
//                                         <div>
//                                             {sizes.map((size, index) => (
//                                                 <Form.Check
//                                                     key={index}
//                                                     type="checkbox"
//                                                     onChange={handleCheckBoxChange}
//                                                     name="size"
//                                                     value={size}
//                                                     label={size}
//                                                     className="mb-2 transparent-checkbox"
//                                                 />
//                                             ))}
//                                         </div>

//                                     </div>

//                                 </Form.Group>

//                                 {/* Gross Weight */}
//                                 <Form.Group style={{ paddingTop: '10px', marginTop: '20px' }}>
//                                     <Form.Label style={{ color: '#fff', fontfamily: 'Roboto', fontWeight: '500', lineHeight: '1.2', letterSpacing: '0', fontSize: '20px' }}>Gross Weight</Form.Label>
//                                     <div style={{ display: 'flex' }}>
//                                         <Form.Control type="number" style={{
//                                             backgroundColor: 'transparent',
//                                             color: '#fff',
//                                             borderRadius: '3px',
//                                         }} name="gross_weight_min" placeholder="Min" onChange={handleInputChange} />
//                                         <Form.Control type="number" name="gross_weight_max" placeholder="Max" onChange={handleInputChange} style={{ marginLeft: '10px', backgroundColor: 'transparent', color: '#fff', borderRadius: '3px' }} />
//                                     </div>
//                                 </Form.Group>

//                                 {/* Net Weight */}
//                                 <Form.Group style={{ paddingTop: '10px', marginTop: '20px' }}>
//                                     <Form.Label style={{ color: '#fff', fontfamily: 'Roboto', fontWeight: '500', lineHeight: '1.2', letterSpacing: '0', fontSize: '20px' }}>Net Weight</Form.Label>
//                                     <div style={{ display: 'flex', marginTop: '3px' }}>
//                                         <Form.Control type="number" style={{ backgroundColor: 'transparent', color: '#fff', borderRadius: '3px' }} name="net_weight_min" placeholder="Min" onChange={handleInputChange} />
//                                         <Form.Control type="number" name="net_weight_max" placeholder="Max" onChange={handleInputChange} style={{ marginLeft: '10px', backgroundColor: 'transparent', color: '#fff', borderRadius: '3px' }} />
//                                     </div>
//                                 </Form.Group>

//                                 {/* Stone Weight */}
//                                 <Form.Group style={{ paddingTop: '10px', marginTop: '20px' }}>
//                                     <Form.Label style={{ color: '#fff', fontfamily: 'Roboto', fontWeight: '500', lineHeight: '1.2', letterSpacing: '0', fontSize: '20px' }}>Stone Weight</Form.Label>
//                                     <div style={{ display: 'flex' }}>
//                                         <Form.Control type="number" style={{ backgroundColor: 'transparent', color: '#fff', borderRadius: '3px' }} name="stone_weight_min" placeholder="Min" onChange={handleInputChange} />
//                                         <Form.Control type="number" name="stone_weight_max" placeholder="Max" onChange={handleInputChange} style={{ marginLeft: '10px', backgroundColor: 'transparent', color: '#fff', borderRadius: '3px' }} />
//                                     </div>
//                                 </Form.Group>

//                                 {/* Apply Filters Button */}
//                                 <div align="center" className="apply_button" style={{ marginTop: '50px' }}>
//                                     <Button style={{ backgroundColor: '#fff', color: '#23395B', boxShadow: '0px 0px 7px 0px #000', border: 'none' }} className="pe-4 ps-4 mt-4 me-4" variant="light" onClick={applyFilters}>Apply Filters</Button>
//                                     <Button style={{ backgroundColor: '#fff', color: '#23395B', boxShadow: '0px 0px 7px 0px #000', border: 'none' }} className="pe-4 ps-4 mt-4 me-4" variant="" onClick={clearFilters}>Clear Filters</Button>
//                                     {/* <Button style={{ backgroundColor: '#fff', color: '#23395B', boxShadow: '0px 0px 7px 0px #000', border: 'none' }} className="pe-4 ps-4 mt-4 me-4" variant="light" onClick={ClearFilters}>clear Filters</Button> */}
//                                 </div>
//                             </Form>
//                         </div>

//                     </Col>

//                     {/* Offcanvas Sidebar for Mobile */}
//                     <Offcanvas show={showSidebar} onHide={handleSidebarClose} placement="start">
//                         <Offcanvas.Header className="custom-offcanvas-header" variant="light" closeButton style={{ backgroundColor: '#396D72', color: '#fff', }}>
//                             <Offcanvas.Title>Menu</Offcanvas.Title>
//                         </Offcanvas.Header>
//                         <Offcanvas.Body style={{ backgroundColor: '#396D72' }}>
//                             <Dropdown>
//                                 <Dropdown.Toggle variant="" style={{ color: '#fff', border: 'none', fontSize: '20px' }}>{selectedItem}</Dropdown.Toggle>
//                                 <Dropdown.Menu>
//                                     {/* <Dropdown.Item onClick={() => handleClick("All")} key="all">All Products</Dropdown.Item> */}
//                                     {itemData.map((item, index) => (
//                                         <Dropdown.Item key={index} onClick={() => handleClick(item)}>{item.item_name}</Dropdown.Item>
//                                     ))}
//                                 </Dropdown.Menu>
//                             </Dropdown>

//                             <div align='end' >
//                                 <Navbar.Brand className="" ><a href="/add-to-cartdetails"><GrCart style={{ width: '33px ', height: '31px', color: '#fff' }} /></a></Navbar.Brand>
//                             </div>

//                             {/* filters */}
//                             <div>
//                                 <Form style={{ paddingTop: '20px' }}>
//                                     {/* <Form.Label style={{ color: '#fff', fontSize: '30px', fontFamily: 'Poppins', textDecoration: "underline" }}>Apply Filters</Form.Label> */}
//                                     <Form.Group >
//                                         <Form.Label style={{ color: '#fff', fontfamily: 'Roboto', fontWeight: '500', lineHeight: '1.2', letterSpacing: '0', fontSize: '20px' }}>Size</Form.Label> <br />
//                                         <div className="checks" style={{ display: "flex", color: "#fff", justifyContent: "space-between", backgroundColor: "transparent" }}>
//                                             <div>
//                                                 {sizes.map((size, index) => (
//                                                     <Form.Check
//                                                         key={index}
//                                                         type="checkbox"
//                                                         onChange={handleCheckBoxChange}
//                                                         name="size_min"
//                                                         value={size}
//                                                         label={size}
//                                                         className="mb-2 transparent-checkbox"
//                                                     />
//                                                 ))}
//                                             </div>
//                                             <div style={{ marginRight: "80px" }}>
//                                                 {sizes.map((size, index) => (
//                                                     <Form.Check
//                                                         key={`max-${index}`}
//                                                         type="checkbox"
//                                                         onChange={handleCheckBoxChange}
//                                                         name="size_max"
//                                                         value={size}
//                                                         label={size}
//                                                         className="mb-2 transparent-checkbox"
//                                                     />
//                                                 ))}
//                                             </div>
//                                         </div>

//                                     </Form.Group>
//                                     {/* Gross Weight */}
//                                     <Form.Group style={{ paddingTop: '10px' }}>
//                                         <Form.Label style={{ color: 'white', fontSize: '20px', fontFamily: 'Poppins' }}>Gross Weight</Form.Label>
//                                         <div style={{ display: 'flex' }}>
//                                             <Form.Control style={{
//                                                 backgroundColor: 'transparent',
//                                                 color: '#fff',

//                                             }} type="number" name="gross_weight_min" placeholder="Min" onChange={handleInputChange} />
//                                             <Form.Control type="number" name="gross_weight_max" placeholder="Max" onChange={handleInputChange} style={{ marginLeft: '10px', backgroundColor: 'transparent', color: '#fff' }} />
//                                         </div>
//                                     </Form.Group>

//                                     {/* Net Weight */}
//                                     <Form.Group style={{ paddingTop: '10px' }}>
//                                         <Form.Label style={{ color: 'white', fontSize: '20px', fontFamily: 'Poppins' }}>Net Weight</Form.Label>
//                                         <div style={{ display: 'flex' }}>
//                                             <Form.Control style={{
//                                                 backgroundColor: 'transparent',
//                                                 color: '#fff'
//                                             }} type="number" name="net_weight_min" placeholder="Min" onChange={handleInputChange} />
//                                             <Form.Control type="number" name="net_weight_max" placeholder="Max" onChange={handleInputChange} style={{ marginLeft: '10px', backgroundColor: 'transparent', color: '#fff' }} />
//                                         </div>
//                                     </Form.Group>

//                                     {/* Stone Weight */}
//                                     <Form.Group style={{ paddingTop: '10px' }}>
//                                         <Form.Label style={{ color: 'white', fontSize: '20px', fontFamily: 'Poppins' }}>Stone Weight</Form.Label>
//                                         <div style={{ display: 'flex' }}>
//                                             <Form.Control type="number" style={{
//                                                 backgroundColor: 'transparent',
//                                                 color: '#fff'
//                                             }} name="stone_weight_min" placeholder="Min" onChange={handleInputChange} />
//                                             <Form.Control type="number" name="stone_weight_max" placeholder="Max" onChange={handleInputChange} style={{ marginLeft: '10px', backgroundColor: 'transparent', color: '#fff' }} />
//                                         </div>
//                                     </Form.Group>

//                                     {/* Apply Filters Button */}
//                                     <div align="center" style={{ marginTop: '50px' }} className="">
//                                         <Button style={{ backgroundColor: '#fff', color: '#23395B', boxShadow: '0px 0px 7px 0px #000', border: 'none' }} className="pe-4 ps-4 mt-4 me-4" variant="" onClick={applyFilters}>Apply Filters</Button>
//                                         <Button style={{ backgroundColor: '#fff', color: '#23395B', boxShadow: '0px 0px 7px 0px #000', border: 'none' }} className="pe-4 ps-4 mt-4 me-4" variant="" onClick={clearFilters}>Clear Filters</Button>
//                                     </div>
//                                 </Form>
//                             </div>

//                         </Offcanvas.Body>
//                     </Offcanvas>

//                     {/* //product items */}

//                     <Col md={9} className="scrollable-content" style={{ marginTop: '70px' }} >
//                         <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-evenly', marginTop: '10px', gap: '10px' }}>
//                             {selectProduct ?
//                                 displayData && displayData.length > 0 ? (
//                                     displayData.map((product) => (
//                                         <Card style={{ width: '18rem', height: '30rem', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', borderRadius: '15px' }}>
//                                             <div style={{ width: '100%', height: '100%', overflow: 'hidden', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
//                                                 <img
//                                                     onClick={() => navigate(`/customer-items/${product.id}`)}
//                                                     variant="top"
//                                                     src={product.image ? product.image : "./images/noimage.jpg"}
//                                                     style={{
//                                                         width: '100%',
//                                                         height: '100%',
//                                                         // backgroundSize: 'contain',
//                                                         borderTopLeftRadius: '10px',
//                                                         borderTopRightRadius: '10px',
//                                                         objectFit: 'cover',
//                                                     }}
//                                                 />
//                                             </div>

//                                             <Card.Body style={{ display: "flex", flexDirection: 'column', justifyContent: 'space-between', flexGrow: 1, }}>

//                                                 <div align="center">
//                                                     <p style={{ fontFamily: 'Roboto', fontWeight: '600', fontSize: '18px', lineHeight: '0', letterSpacing: '0' }}>{product.item_tag}</p>
//                                                     <p style={{ fontFamily: 'Roboto', fontWeight: '600', fontSize: '18px', lineHeight: '1', letterSpacing: '0' }}>{product.item_name}</p>
//                                                 </div>
//                                                 <Card.Text style={{ marginTop: '10px', marginLeft: '25%' }}>

//                                                     <p style={{ lineHeight: '0.5', fontFamily: 'Roboto', fontWeight: '400' }}>Gross Wt&nbsp; : {product.gross_weight} gm</p>
//                                                     <p style={{ lineHeight: '0.5', fontFamily: 'Roboto', fontWeight: '400' }}>Net Wt&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; : {product.net_weight} gm</p>
//                                                     <p style={{ lineHeight: '0.5', fontFamily: 'Roboto', fontWeight: '400' }}>Stone Wt&nbsp; : {product.stone_weight} gm</p>
//                                                     <p style={{ lineHeight: '0.5', fontFamily: 'Roboto', fontWeight: '400' }}>Size&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;: {product.size} </p>
//                                                 </Card.Text>

//                                             </Card.Body>
//                                             <Button
//                                                 variant="primary"
//                                                 className="w-100 mt-2"
//                                                 style={{
//                                                     backgroundColor: cartItems.includes(product.item_tag) ? "#396D72" : '#D1B457',
//                                                     // backgroundColor:'#D1B457',
//                                                     border: 'none',
//                                                     borderBottomLeftRadius: '13px',
//                                                     borderBottomRightRadius: '13px',
//                                                     borderTopRightRadius: '0',
//                                                     borderTopLeftRadius: '0'
//                                                 }}
//                                                 onClick={() => handleAddToCart(product)}
//                                                 disabled={cartItems.includes(product.item_tag)}
//                                             >
//                                                 {cartItems.includes(product.item_tag) ? "Added to Cart" : "Add to Cart"}
//                                             </Button>
//                                         </Card>

//                                     ))
//                                 ) : (
//                                     <Col className="text-centere">
//                                         <p style={{ fontSize: "24px", fontWeight: "bold", alignItems: 'center' }}>No Item found</p>
//                                     </Col>
//                                 )
//                                 :
//                                 (
//                                     <Col className="text-centere">
//                                         <p style={{ fontSize: "24px", fontWeight: "bold", alignItems: 'center' }}> Select Product</p>
//                                     </Col>
//                                 )
//                             }

//                         </div>

//                     </Col>

//                 </Row>
//             </Container>

//             <hr style={{ border: '1px solid #000000' }} />

//             <div
//                 className="address"
//                 style={{
//                     // marginLeft: "auto",
//                     // marginRight: "auto",
//                     marginTop: "30px",
//                     // borderTop: "1px solid",
//                     fontFamily: "Roboto",
//                     fontWeight: "500",
//                     maxWidth: "600px", // Limit the width for better readability on larger screens
//                     padding: "0 20px", // Add padding for smaller screens
//                 }}
//             >
//                 <div>
//                     <h3 style={{ fontSize: "20px", fontFamily: "Roboto", fontWeight: "500", marginTop: "30px", lineHeight: '1', letterSpacing: '0' }}>
//                         Shubham Jewellers
//                     </h3>
//                 </div>
//                 <div>
//                     <h2 style={{ fontSize: "20px", fontFamily: "Roboto", fontWeight: "500", marginTop: "20px", lineHeight: '1', letterSpacing: '0' }}>
//                         Address
//                     </h2>
//                     <p style={{ fontSize: "15px", fontFamily: "Roboto", fontWeight: "500", marginTop: "20px", lineHeight: '1', letterSpacing: '0' }}>
//                         Sri Shubham jewellery, 2 nd floor 201/202, mayur kushal complex abids, Gunfoundry, Hyderabad 500001,
//                         Telegana, India
//                     </p>
//                 </div>
//                 <div>
//                     <h2 style={{ fontSize: "20px", fontFamily: "Roboto", fontWeight: "500", lineHeight: '1', letterSpacing: '0' }}>Phone</h2>
//                     <p style={{ fontSize: "15px", fontFamily: "Roboto", fontWeight: "500", marginTop: "20px", lineHeight: '1', letterSpacing: '0' }}>+919949946000</p>
//                 </div>
//                 <div>
//                     <h2 style={{ fontSize: "20px", fontFamily: "Roboto", fontWeight: "500", lineHeight: '1', letterSpacing: '0' }}>Email</h2>
//                     <p style={{ fontSize: "15px", fontFamily: "Roboto", fontWeight: "500", marginTop: "20px", lineHeight: '1', letterSpacing: '0' }}>srishubhamjewellers@gmail.com</p>
//                 </div>

//             </div>
//             <div align="center" style={{ fontFamily: "Roboto", marginTop: "30px" }}>
//                 <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexWrap: 'wrap' }}>
//                     <h4 align="center" style={{ fontSize: '14px', marginTop: '31px', color: '#35646E' }}>POWERED BY</h4>
//                     <div
//                         style={{
//                             width: "100px",
//                             height: "50px",
//                             borderRadius: "10px",
//                             overflow: "hidden",
//                             alignItems: "center",
//                             justifyContent: "center",
//                             marginLeft: '5px' //add some space between text and logo
//                         }}
//                     >
//                         <img src={brandLogo} alt="Brandlogo" style={{ width: "100%", height: "100%", backgroundSize: "cover" }} />
//                     </div>
//                 </div>
//             </div>
//         </div>
// );
// };

// export default SlideBar;

////////////////////////////////////

// import React, { useState, useEffect } from "react";
// import {
//     Navbar,
//     Nav,
//     Container,
//     Row,
//     Col,
//     Card,
//     Button,
//     ListGroup,
//     Form,
// } from "react-bootstrap";
// import Dropdown from "react-bootstrap/Dropdown";
// import { useNavigate } from "react-router-dom";
// import { Link } from "react-router-dom";
// import { List } from "react-bootstrap-icons";
// import "../style/admin.css";
// import Spinner from "react-bootstrap/Spinner";
// import axios from "axios";
// import { GrCart } from "react-icons/gr";
// import Modal from "react-bootstrap/Modal";
// import Offcanvas from "react-bootstrap/Offcanvas";
// import { RxCross1, RxHamburgerMenu } from "react-icons/rx";
// import { useContext } from 'react';
// import { CartContext } from './CartContext';

// const SlideBar = () => {
//     const [cart, setCart] = useState([]);
//     const [sidebarOpen, setSidebarOpen] = useState(false);
//     const [displayData, setDisplayData] = useState([]);
//     const [itemCode, setItemCode] = useState("");
//     const [loading, setLoading] = useState(false);
//     const [allData, setAllData] = useState([]);
//     const [selectedItem, setSelectedItem] = useState("Products");
//     const [show, setShow] = useState(false);
//     const [showSidebar, setShowSidebar] = useState(false);
//     const [brandLogo, setBrandLogo] = useState(null);

//     // const [cartCount, setCartCount] = useState(0);

//     const [AllSizes, setAllSizes] = useState([]);
//     // const [maxSizes, setMaxSizes] = useState([]);
//     const [isLoading, setIsLoading] = useState(false);
//     const [apiData, setApiData] = useState(null);
//     const [error, setError] = useState(null);

//     const handleClose = () => setShow(false);
//     const handleShow = () => setShow(true);
//     const [count, setcount] = useState(0);
//     const [logo, setLogo] = useState(null);
//     const [name, setName] = useState("")
//     const [customerName, setCustomerName] = useState("");
//     const [sizes, setSizes] = useState([]);

//     const [selectProduct, setSelectProduct] = useState(false);

//     const Token = localStorage.getItem("token");

//     const navigate = useNavigate();

//     useEffect(() => {
//         fetchData();
//         // handleAllitem();
//         fetchdatas();
//     }, []);

//     // customer name

//     const customerApi = "${apibasePath}/client/customer-name/";

//     const { cartCount } = useContext(CartContext);

//     const fetchCustomerName = async () => {

//         const Token = localStorage.getItem("token");

//         try {

//             let response = await axios.get(customerApi, {
//                 headers: {
//                     Authorization: `bearer ${Token}`,
//                     "Content-Type": "application/json",
//                 },
//             });
//             console.log("Customer API Response:", response.data);

//             if (response.data?.name) {
//                 setCustomerName(response.data.name); // Set name only if it exists
//             } else {
//                 console.warn("Customer name not found in API response");
//             }

//         } catch (error) {
//             console.error("Error fetching customer name:", error);
//         }
//     };

//     useEffect(() => {

//         fetchCustomerName(); // Call function inside useEffect
//     }, []);
//     // const addToCart = (product) => {
//     //     setCart([...cart, product]);
//     // };

//     const handleClick = (item) => {
//         // if (item === "Products") {
//         //     handleAllitem();
//         // } else {
//         // fetchItemData(item);
//         // }
//         fetchItemData(item);
//         setSelectedItem(item === "Products" ? "Products" : item.item_name);
//     };

//     const All_Api = "${apibasePath}/client/customer-item-stock-list/";

//     const handleAllitem = async () => {
//         // const Token = localStorage.getItem("token");
//         <h1>Select Product</h1>
//         try {
//             setLoading(true)
//             const res = await axios.get(All_Api, {
//                 headers: {
//                     Authorization: `bearer ${Token}`,
//                     "Content-Type": "application/json",
//                 },
//             });
//             setSelectedItem("Products");
//             setDisplayData(res.data);
//             setLoading(false)
//         } catch (error) {
//             console.error(error);
//         }
//     };

//     const fetchItemData = async (item) => {
//         const Token = localStorage.getItem("token");

//         setItemCode(item.item_code);

//         try {
//             // setLoading(true);
//             const res = await axios.get(
//                 `${apibasePath}/client/customer-item-stock/${item.item_code}/`,
//                 {
//                     headers: {
//                         Authorization: `bearer ${Token}`,
//                         "Content-Type": "application/json",
//                     },
//                 }
//             );

//             setDisplayData(res?.data);
//             setSelectProduct(true)
//             // setLoading(false);
//         } catch (error) {
//             console.error("Error while getting data", error);
//             // setLoading(false);
//         }
//     };

//     const [filters, setFilters] = useState({
//         gross_weight_min: "",
//         gross_weight_max: "",
//         net_weight_min: "",
//         net_weight_max: "",
//         stone_weight_min: "",
//         stone_weight_max: "",
//         size_min: "",
//         size_max: "",
//     });

// const [selectedSizes, setSelectedSizes] = useState([]);

// useEffect(() => {
//   const storedFilters = localStorage.getItem("filters");
//   const storedSelectedItem = localStorage.getItem("selectedItem");
//   const storedAllSizes = localStorage.getItem("allSizes");
//   const storedDisplayData = localStorage.getItem("displayData");
//   const storedSelectProduct = localStorage.getItem("selectProduct");

//   if (storedFilters) setFilters(JSON.parse(storedFilters));
//   if (storedSelectedItem) setSelectedItem(JSON.parse(storedSelectedItem));
//   if (storedAllSizes) setAllSizes(JSON.parse(storedAllSizes));
//   if (storedDisplayData) setDisplayData(JSON.parse(storedDisplayData));
//   if (storedSelectProduct) setSelectProduct(JSON.parse(storedSelectProduct));
// }, []);

// useEffect(() => {
//   localStorage.setItem("filters", JSON.stringify(filters));
//   localStorage.setItem("selectedItem", JSON.stringify(selectedItem));
//   localStorage.setItem("allSizes", JSON.stringify(AllSizes));
//   localStorage.setItem("displayData", JSON.stringify(displayData));
//   localStorage.setItem("selectProduct", JSON.stringify(selectProduct));
// }, [filters, selectedItem, AllSizes, displayData, selectProduct]);

//     const applyFilters = async () => {
//         const Token = localStorage.getItem("token");

//         try {
//             // setLoading(true);

//             // Build query parameters
//             const queryParams = new URLSearchParams();

//             // Add checkbox filters
//             if (AllSizes.length > 0) {
//                 queryParams.append("size", AllSizes.join(","));
//             }

//             Object.entries(filters).forEach(([key, value]) => {
//                 if (value !== "") {
//                     queryParams.append(key, value);
//                 }
//             });

//             const url = `${apibasePath}/client/customer-item-stock-list/?${queryParams.toString()}`;

//             const response = await fetch(url, {
//                 method: 'GET',
//                 headers: {
//                     Authorization: `bearer ${Token}`,
//                     'Content-Type': 'application/json',
//                 },
//             });
//             console.log('fyxgsfhdashcs', response);
//             if (!response.ok) {
//                 throw new Error(`HTTP error! status: ${response.status}`);

//             }

//             const data = await response.json();
//             console.log(data, "data");

//             setDisplayData(data);
//         } catch (error) {
//             console.error("Error while fetching data", error);

//         } finally {
//             // setLoading(false);
//         }
//     };

//  const [selectedData, setSelectedData] = useState([]);

//     const clearFilters = () => {
//         const cleared = {
//           gross_weight_min: "",
//           gross_weight_max: "",
//           net_weight_min: "",
//           net_weight_max: "",
//           stone_weight_min: "",
//           stone_weight_max: "",
//           size: ""
//         };

//         setFilters(cleared);
//         setAllSizes([]);
//         setSelectedData([]);

//         localStorage.removeItem('selectedSizes');
//         Object.keys(cleared).forEach(key => {
//           localStorage.removeItem(key);
//         });

//         // Clear input fields directly if they exist in the DOM
//         document.querySelectorAll('input[type="number"]').forEach(input => {
//           if (input.name === 'gross_weight_min' ||
//               input.name === 'gross_weight_max' ||
//               input.name === 'net_weight_min' ||
//               input.name === 'net_weight_max' ||
//               input.name === 'stone_weight_min' ||
//               input.name === 'stone_weight_max') {
//             input.value = "";
//           }
//         });

//         document.querySelectorAll('input[type=checkbox]').forEach(el => el.checked = false);

//         // If you have size input as text field. clear that also.
//         const sizeInput = document.querySelector('input[name="size"]');
//         if(sizeInput){
//           sizeInput.value = "";
//         }

//     //    fetchItemData()
//         // If you have some handle function to re-render all item, call it here.
//         // handleAllitem(); // uncomment if needed.
//       };

//     const handleInputChange = (e) => {
//         const { name, value } = e.target;
//         setFilters((prevFilters) => ({ ...prevFilters, [name]: value }));
//     };

//     const handleCheckBoxChange = (event) => {
//         const { name, checked, value } = event.target;

//         if (name === "size") {
//             setAllSizes(checked ? [value] : AllSizes.filter((size) => size !== value)); // Modify this line
//         }
//     };

//     const sizeApi = "${apibasePath}/client/available-sizes/";

//     useEffect(() => {
//         const fetchSizeData = async () => {
//             try {
//                 const response = await axios.get(sizeApi, {
//                     headers: {
//                         Authorization: `bearer ${Token}`,
//                         "Content-Type": 'application/json'
//                     }
//                 });
//                 console.log(response);
//                 setSizes(response.data); // Assuming response.data is an array of size values
//             } catch (error) {
//                 console.error("Error fetching sizes:", error);
//             }
//         };

//         fetchSizeData();
//     }, []);

//     const API_URL = "${apibasePath}/client/cart/add/";

//     const { cartItems, setCartItems } = useContext(CartContext);

//     const handleAddToCart = async (product) => {
//         const Token = localStorage.getItem("token");
//         try {
//             const response = await axios.post(API_URL, product, {
//                 headers: {
//                     Authorization: `bearer ${Token}`,
//                     "Content-Type": "application/json",
//                 },
//             });

//             const newCart = [...cartItems, product.item_tag];
//             setCartItems(newCart);
//             console.log("button cart list", cartItems);
//             setLoading(false)
//         } catch (error) {
//             console.error("Error adding to cart", error);
//             if (error.response?.status === 400) {
//                 if (!cartItems.includes(product.item_tag)) {
//                     setCartItems([...cartItems, product.item_tag]);
//                 }
//             } else {
//                 alert("An error occurred while adding to cart.");
//             }
//         }
//     };

//     const Api_Url = "${apibasePath}/client/customer-items/";

//     const [itemData, setItemData] = useState([]);

//     const fetchData = async () => {
//         const Token = localStorage.getItem("token");

//         try {
//             setLoading(true)
//             const res = await axios.get(Api_Url, {
//                 headers: {
//                     Authorization: `bearer ${Token}`,
//                 },
//             });
//             setItemData(res.data);
//             setLoading(false)
//         } catch (error) {
//             console.error("error", error);
//         }
//     };

//     if (loading) {
//         return (
//             <div
//                 style={{
//                     top: "50%",
//                     left: "50%",
//                     translate: ("-50%", "-50%"),
//                     position: "absolute",
//                 }}
//                 className="slide"
//             >
//                 <Spinner animation="border" role="status" variant="primary">
//                     <span className="visually-hidden">Loading...</span>
//                 </Spinner>
//             </div>
//         );
//     }

//     const Api_url = "${apibasePath}/client/profiles/company/";

//     const fetchdatas = async () => {
//         try {
//             const response = await axios.get(Api_url, { headers: { "Content-Type": "application/json" } });
//             setLogo(response.data.logo);
//             setName(response.data.name);
//         } catch (error) {
//             console.error("Error fetching company details:", error);
//         }
//     };

//     const handleSidebarClose = () => setShowSidebar(false);
//     const handleSidebarShow = () => setShowSidebar(true);

//     const ClearFilters = () => {

//     }

//     return (
//         <div className="slide">

//             <Navbar className="bg-body-tertiary fixed-top" expand="md">
//                 <Container fluid>
//                     <Navbar.Brand>
//                         <div style={{ width: "100px", height: '50px', borderRadius: '10px', overflow: 'hidden' }}>
//                             <img src={logo} alt="companylogo" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
//                         </div>
//                     </Navbar.Brand>
//                     <Navbar.Brand style={{ color: '#23395B', fontFamily: 'Roboto', fontWeight: '600', marginRight: 'auto', fontSize: '17px' }}>
//                         {name}
//                     </Navbar.Brand>
//                     <Navbar.Brand style={{ color: '#23395B', fontFamily: 'Roboto', fontWeight: '600', marginRight: 'auto', fontSize: '17px' }}>
//                         {customerName}'s Shopping Cart
//                     </Navbar.Brand>
//                     <div className="d-flex align-items-center">
//                         <Button variant="outline-light" className="d-md-none" onClick={handleSidebarShow}>
//                             <RxHamburgerMenu style={{ width: '30px', height: '30px', cursor: 'pointer', color: '#000' }} />
//                         </Button>
//                         <Navbar.Brand className="cart">
//                             {/* <a href="/add-to-cartdetails">
//                                 <GrCart style={{ width: '30px', height: '30px', color: '#396D72' }} />
//                             </a> */}
//                             <a href="/add-to-cartdetails" style={{ position: 'relative' }}>
//                                 <GrCart style={{ width: '30px', height: '30px', color: '#396D72' }} />
//                                 {cartCount > 0 && (
//                                     <span style={{
//                                         position: 'absolute',
//                                         top: '-5px',
//                                         right: '-5px',
//                                         backgroundColor: 'red',
//                                         color: 'white',
//                                         borderRadius: '50%',
//                                         padding: '4px 7px',
//                                         fontSize: '12px',
//                                     }}>
//                                         {cartCount}
//                                     </span>
//                                 )}
//                             </a>
//                         </Navbar.Brand>
//                     </div>
//                 </Container>
//             </Navbar>

//             <Container fluid    >
//                 <Row>
//                     {/* Sidebar - Always visible on larger screens, collapsible on mobile */}

//                     <Col md={3} className="p-3 d-none d-md-block fixed-sidebar " style={{ backgroundColor: "#396D72", height: '130vh', marginTop: '70px' }}>
//                         {/* <h5 className="text-white">Jewellery Items</h5> */}
//                         <Dropdown>
//                             <Dropdown.Toggle variant="" style={{ color: '#fff', border: 'none', fontSize: '20px', fontfamily: 'Roboto', fontWeight: '500', lineHeight: '1.2', letterSpacing: '0', marginLeft: '22px' }}>{selectedItem}</Dropdown.Toggle>
//                             <Dropdown.Menu style={{ backgroundImage: "linear-gradient(to bottom left,#C7E0E3, #FFFFFF ) " }}>
//                                 {/* <Dropdown.Item  key="all" >Products</Dropdown.Item> */}
//                                 {itemData.map((item, index) => (
//                                     <Dropdown.Item key={index} onClick={() => handleClick(item)} >{item.item_name}</Dropdown.Item>
//                                 ))}
//                             </Dropdown.Menu>
//                         </Dropdown>

//                         {/* filters */}

//                         <div>
//                             <Form style={{ paddingTop: '20px', marginLeft: '30px' }}>
//                                 {/* <Form.Label style={{ color: '#fff', fontSize: '30px', fontFamily: 'Poppins', textDecoration: "underline" }}>Apply Filters</Form.Label> */}
//                                 <Form.Group >
//                                     <Form.Label style={{ color: '#fff', fontfamily: 'Roboto', fontWeight: '500', lineHeight: '1.2', letterSpacing: '0', fontSize: '20px' }}>Size</Form.Label> <br />
//                                     <div className="checks" style={{ display: "flex", color: "#fff", justifyContent: "space-between", backgroundColor: "transparent" }}>
//                                         <div>
//                                             {sizes.map((size, index) => (
//                                                 <Form.Check
//                                                     key={index}
//                                                     type="checkbox"
//                                                     onChange={handleCheckBoxChange}
//                                                     name="size"
//                                                     value={size}
//                                                     label={size}
//                                                     className="mb-2 transparent-checkbox"
//                                                 />
//                                             ))}
//                                         </div>

//                                     </div>

//                                 </Form.Group>

//                                 {/* Gross Weight */}
//                                 <Form.Group style={{ paddingTop: '10px', marginTop: '20px' }}>
//                                     <Form.Label style={{ color: '#fff', fontfamily: 'Roboto', fontWeight: '500', lineHeight: '1.2', letterSpacing: '0', fontSize: '20px' }}>Gross Weight</Form.Label>
//                                     <div style={{ display: 'flex' }}>
//                                         <Form.Control type="number" style={{
//                                             backgroundColor: 'transparent',
//                                             color: '#fff',
//                                             borderRadius: '3px',
//                                         }} name="gross_weight_min" placeholder="Min" onChange={handleInputChange} />
//                                         <Form.Control type="number" name="gross_weight_max" placeholder="Max" onChange={handleInputChange} style={{ marginLeft: '10px', backgroundColor: 'transparent', color: '#fff', borderRadius: '3px' }} />
//                                     </div>
//                                 </Form.Group>

//                                 {/* Net Weight */}
//                                 <Form.Group style={{ paddingTop: '10px', marginTop: '20px' }}>
//                                     <Form.Label style={{ color: '#fff', fontfamily: 'Roboto', fontWeight: '500', lineHeight: '1.2', letterSpacing: '0', fontSize: '20px' }}>Net Weight</Form.Label>
//                                     <div style={{ display: 'flex', marginTop: '3px' }}>
//                                         <Form.Control type="number" style={{ backgroundColor: 'transparent', color: '#fff', borderRadius: '3px' }} name="net_weight_min" placeholder="Min" onChange={handleInputChange} />
//                                         <Form.Control type="number" name="net_weight_max" placeholder="Max" onChange={handleInputChange} style={{ marginLeft: '10px', backgroundColor: 'transparent', color: '#fff', borderRadius: '3px' }} />
//                                     </div>
//                                 </Form.Group>

//                                 {/* Stone Weight */}
//                                 <Form.Group style={{ paddingTop: '10px', marginTop: '20px' }}>
//                                     <Form.Label style={{ color: '#fff', fontfamily: 'Roboto', fontWeight: '500', lineHeight: '1.2', letterSpacing: '0', fontSize: '20px' }}>Stone Weight</Form.Label>
//                                     <div style={{ display: 'flex' }}>
//                                         <Form.Control type="number" style={{ backgroundColor: 'transparent', color: '#fff', borderRadius: '3px' }} name="stone_weight_min" placeholder="Min" onChange={handleInputChange} />
//                                         <Form.Control type="number" name="stone_weight_max" placeholder="Max" onChange={handleInputChange} style={{ marginLeft: '10px', backgroundColor: 'transparent', color: '#fff', borderRadius: '3px' }} />
//                                     </div>
//                                 </Form.Group>

//                                 {/* Apply Filters Button */}
//                                 <div align="center" className="apply_button" style={{ marginTop: '50px' }}>
//                                     <Button style={{ backgroundColor: '#fff', color: '#23395B', boxShadow: '0px 0px 7px 0px #000', border: 'none' }} className="pe-4 ps-4 mt-4 me-4" variant="light" onClick={applyFilters}>Apply Filters</Button>
//                                     <Button style={{ backgroundColor: '#fff', color: '#23395B', boxShadow: '0px 0px 7px 0px #000', border: 'none' }} className="pe-4 ps-4 mt-4 me-4" variant="light" onClick={clearFilters}>Clear Filters</Button>
//                                     {/* <Button style={{ backgroundColor: '#fff', color: '#23395B', boxShadow: '0px 0px 7px 0px #000', border: 'none' }} className="pe-4 ps-4 mt-4 me-4" variant="light" onClick={ClearFilters}>clear Filters</Button> */}
//                                 </div>
//                             </Form>
//                         </div>

//                     </Col>

//                     {/* Offcanvas Sidebar for Mobile */}
//                     <Offcanvas show={showSidebar} onHide={handleSidebarClose} placement="start">
//                         <Offcanvas.Header className="custom-offcanvas-header" variant="light" closeButton style={{ backgroundColor: '#396D72', color: '#fff', }}>
//                             <Offcanvas.Title>Menu</Offcanvas.Title>
//                         </Offcanvas.Header>
//                         <Offcanvas.Body style={{ backgroundColor: '#396D72' }}>
//                             <Dropdown>
//                                 <Dropdown.Toggle variant="" style={{ color: '#fff', border: 'none', fontSize: '20px' }}>{selectedItem}</Dropdown.Toggle>
//                                 <Dropdown.Menu>
//                                     {/* <Dropdown.Item onClick={() => handleClick("All")} key="all">All Products</Dropdown.Item> */}
//                                     {itemData.map((item, index) => (
//                                         <Dropdown.Item key={index} onClick={() => handleClick(item)}>{item.item_name}</Dropdown.Item>
//                                     ))}
//                                 </Dropdown.Menu>
//                             </Dropdown>

//                             <div align='end' >
//                                 <Navbar.Brand className="" ><a href="/add-to-cartdetails"><GrCart style={{ width: '33px ', height: '31px', color: '#fff' }} /></a></Navbar.Brand>
//                             </div>

//                             {/* filters */}
//                             <div>
//                                 <Form style={{ paddingTop: '20px' }}>
//                                     {/* <Form.Label style={{ color: '#fff', fontSize: '30px', fontFamily: 'Poppins', textDecoration: "underline" }}>Apply Filters</Form.Label> */}
//                                     <Form.Group >
//                                         <Form.Label style={{ color: '#fff', fontfamily: 'Roboto', fontWeight: '500', lineHeight: '1.2', letterSpacing: '0', fontSize: '20px' }}>Size</Form.Label> <br />
//                                         <div className="checks" style={{ display: "flex", color: "#fff", justifyContent: "space-between", backgroundColor: "transparent" }}>
//                                             <div>
//                                                 {sizes.map((size, index) => (
//                                                     <Form.Check
//                                                         key={index}
//                                                         type="checkbox"
//                                                         onChange={handleCheckBoxChange}
//                                                         name="size_min"
//                                                         value={size}
//                                                         label={size}
//                                                         className="mb-2 transparent-checkbox"
//                                                     />
//                                                 ))}
//                                             </div>
//                                             <div style={{ marginRight: "80px" }}>
//                                                 {sizes.map((size, index) => (
//                                                     <Form.Check
//                                                         key={`max-${index}`}
//                                                         type="checkbox"
//                                                         onChange={handleCheckBoxChange}
//                                                         name="size_max"
//                                                         value={size}
//                                                         label={size}
//                                                         className="mb-2 transparent-checkbox"
//                                                     />
//                                                 ))}
//                                             </div>
//                                         </div>

//                                     </Form.Group>
//                                     {/* Gross Weight */}
//                                     <Form.Group style={{ paddingTop: '10px' }}>
//                                         <Form.Label style={{ color: 'white', fontSize: '20px', fontFamily: 'Poppins' }}>Gross Weight</Form.Label>
//                                         <div style={{ display: 'flex' }}>
//                                             <Form.Control style={{
//                                                 backgroundColor: 'transparent',
//                                                 color: '#fff',

//                                             }} type="number" name="gross_weight_min" placeholder="Min" onChange={handleInputChange} />
//                                             <Form.Control type="number" name="gross_weight_max" placeholder="Max" onChange={handleInputChange} style={{ marginLeft: '10px', backgroundColor: 'transparent', color: '#fff' }} />
//                                         </div>
//                                     </Form.Group>

//                                     {/* Net Weight */}
//                                     <Form.Group style={{ paddingTop: '10px' }}>
//                                         <Form.Label style={{ color: 'white', fontSize: '20px', fontFamily: 'Poppins' }}>Net Weight</Form.Label>
//                                         <div style={{ display: 'flex' }}>
//                                             <Form.Control style={{
//                                                 backgroundColor: 'transparent',
//                                                 color: '#fff'
//                                             }} type="number" name="net_weight_min" placeholder="Min" onChange={handleInputChange} />
//                                             <Form.Control type="number" name="net_weight_max" placeholder="Max" onChange={handleInputChange} style={{ marginLeft: '10px', backgroundColor: 'transparent', color: '#fff' }} />
//                                         </div>
//                                     </Form.Group>

//                                     {/* Stone Weight */}
//                                     <Form.Group style={{ paddingTop: '10px' }}>
//                                         <Form.Label style={{ color: 'white', fontSize: '20px', fontFamily: 'Poppins' }}>Stone Weight</Form.Label>
//                                         <div style={{ display: 'flex' }}>
//                                             <Form.Control type="number" style={{
//                                                 backgroundColor: 'transparent',
//                                                 color: '#fff'
//                                             }} name="stone_weight_min" placeholder="Min" onChange={handleInputChange} />
//                                             <Form.Control type="number" name="stone_weight_max" placeholder="Max" onChange={handleInputChange} style={{ marginLeft: '10px', backgroundColor: 'transparent', color: '#fff' }} />
//                                         </div>
//                                     </Form.Group>

//                                     {/* Apply Filters Button */}
//                                     <div align="center" style={{ marginTop: '50px' }} className="">
//                                         <Button style={{ backgroundColor: '#fff', color: '#23395B', boxShadow: '0px 0px 7px 0px #000', border: 'none' }} className="pe-4 ps-4 mt-4 me-4" variant="" onClick={applyFilters}>Apply Filters</Button>
//                                         <Button style={{ backgroundColor: '#fff', color: '#23395B', boxShadow: '0px 0px 7px 0px #000', border: 'none' }} className="pe-4 ps-4 mt-4 me-4" variant="light" onClick={clearFilters}>Clear Filters</Button>
//                                     </div>
//                                 </Form>
//                             </div>

//                         </Offcanvas.Body>
//                     </Offcanvas>

//                     {/* //product items */}

//                     <Col md={9} className="scrollable-content" style={{ marginTop: '70px' }} >
//                         <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-evenly', marginTop: '10px', gap: '10px' }}>
//                             {selectProduct ?
//                                 displayData && displayData.length > 0 ? (
//                                     displayData.map((product) => (
//                                         <Card style={{ width: '18rem', height: '30rem', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', borderRadius: '15px' }}>
//                                             <div style={{ width: '100%', height: '100%', overflow: 'hidden', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
//                                                 <img
//                                                     onClick={() => navigate(`/customer-items/${product.id}`)}
//                                                     variant="top"
//                                                     src={product.image ? product.image : "./images/noimage.jpg"}
//                                                     style={{
//                                                         width: '100%',
//                                                         height: '100%',
//                                                         // backgroundSize: 'contain',
//                                                         borderTopLeftRadius: '10px',
//                                                         borderTopRightRadius: '10px',
//                                                         objectFit: 'cover',
//                                                     }}
//                                                 />
//                                             </div>

//                                             <Card.Body style={{ display: "flex", flexDirection: 'column', justifyContent: 'space-between', flexGrow: 1, }}>

//                                                 <div align="center">
//                                                     <p style={{ fontFamily: 'Roboto', fontWeight: '600', fontSize: '18px', lineHeight: '0', letterSpacing: '0' }}>{product.item_tag}</p>
//                                                     <p style={{ fontFamily: 'Roboto', fontWeight: '600', fontSize: '18px', lineHeight: '1', letterSpacing: '0' }}>{product.item_name}</p>
//                                                 </div>
//                                                 <Card.Text style={{ marginTop: '10px', marginLeft: '25%' }}>

//                                                     <p style={{ lineHeight: '0.5', fontFamily: 'Roboto', fontWeight: '400' }}>Gross Wt&nbsp; : {product.gross_weight} gm</p>
//                                                     <p style={{ lineHeight: '0.5', fontFamily: 'Roboto', fontWeight: '400' }}>Net Wt&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; : {product.net_weight} gm</p>
//                                                     <p style={{ lineHeight: '0.5', fontFamily: 'Roboto', fontWeight: '400' }}>Stone Wt&nbsp; : {product.stone_weight} gm</p>
//                                                     <p style={{ lineHeight: '0.5', fontFamily: 'Roboto', fontWeight: '400' }}>Size&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;: {product.size} </p>
//                                                 </Card.Text>

//                                             </Card.Body>
//                                             <Button
//                                                 variant="primary"
//                                                 className="w-100 mt-2"
//                                                 style={{
//                                                     backgroundColor: cartItems.includes(product.item_tag) ? "#396D72" : '#D1B457',
//                                                     // backgroundColor:'#D1B457',
//                                                     border: 'none',
//                                                     borderBottomLeftRadius: '13px',
//                                                     borderBottomRightRadius: '13px',
//                                                     borderTopRightRadius: '0',
//                                                     borderTopLeftRadius: '0'
//                                                 }}
//                                                 onClick={() => handleAddToCart(product)}
//                                                 disabled={cartItems.includes(product.item_tag)}
//                                             >
//                                                 {cartItems.includes(product.item_tag) ? "Added to Cart" : "Add to Cart"}
//                                             </Button>
//                                         </Card>

//                                     ))
//                                 ) : (
//                                     <Col className="text-centere">
//                                         <p style={{ fontSize: "24px", fontWeight: "bold", alignItems: 'center' }}>No Item found</p>
//                                     </Col>
//                                 )
//                                 :
//                                 (
//                                     <Col className="text-centere">
//                                         <p style={{ fontSize: "24px", fontWeight: "bold", alignItems: 'center' }}> Select Product</p>
//                                     </Col>
//                                 )
//                             }

//                         </div>

//                     </Col>

//                 </Row>
//             </Container>

//             <hr style={{ border: '1px solid #000000' }} />

//             <div
//                 className="address"
//                 style={{
//                     // marginLeft: "auto",
//                     // marginRight: "auto",
//                     marginTop: "30px",
//                     // borderTop: "1px solid",
//                     fontFamily: "Roboto",
//                     fontWeight: "500",
//                     maxWidth: "600px", // Limit the width for better readability on larger screens
//                     padding: "0 20px", // Add padding for smaller screens
//                 }}
//             >
//                 <div>
//                     <h3 style={{ fontSize: "20px", fontFamily: "Roboto", fontWeight: "500", marginTop: "30px", lineHeight: '1', letterSpacing: '0' }}>
//                         Shubham Jewellers
//                     </h3>
//                 </div>
//                 <div>
//                     <h2 style={{ fontSize: "20px", fontFamily: "Roboto", fontWeight: "500", marginTop: "20px", lineHeight: '1', letterSpacing: '0' }}>
//                         Address
//                     </h2>
//                     <p style={{ fontSize: "15px", fontFamily: "Roboto", fontWeight: "500", marginTop: "20px", lineHeight: '1', letterSpacing: '0' }}>
//                         Sri Shubham jewellery, 2 nd floor 201/202, mayur kushal complex abids, Gunfoundry, Hyderabad 500001,
//                         Telegana, India
//                     </p>
//                 </div>
//                 <div>
//                     <h2 style={{ fontSize: "20px", fontFamily: "Roboto", fontWeight: "500", lineHeight: '1', letterSpacing: '0' }}>Phone</h2>
//                     <p style={{ fontSize: "15px", fontFamily: "Roboto", fontWeight: "500", marginTop: "20px", lineHeight: '1', letterSpacing: '0' }}>+919949946000</p>
//                 </div>
//                 <div>
//                     <h2 style={{ fontSize: "20px", fontFamily: "Roboto", fontWeight: "500", lineHeight: '1', letterSpacing: '0' }}>Email</h2>
//                     <p style={{ fontSize: "15px", fontFamily: "Roboto", fontWeight: "500", marginTop: "20px", lineHeight: '1', letterSpacing: '0' }}>srishubhamjewellers@gmail.com</p>
//                 </div>

//             </div>
//             <div align="center" style={{ fontFamily: "Roboto", marginTop: "30px" }}>
//                 <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexWrap: 'wrap' }}>
//                     <h4 align="center" style={{ fontSize: '14px', marginTop: '31px', color: '#35646E' }}>POWERED BY</h4>
//                     <div
//                         style={{
//                             width: "100px",
//                             height: "50px",
//                             borderRadius: "10px",
//                             overflow: "hidden",
//                             alignItems: "center",
//                             justifyContent: "center",
//                             marginLeft: '5px' //add some space between text and logo
//                         }}
//                     >
//                         <img src={brandLogo} alt="Brandlogo" style={{ width: "100%", height: "100%", backgroundSize: "cover" }} />
//                     </div>
//                 </div>
//             </div>

//         </div>
//     );
// };

// export default SlideBar;

import React, { useState, useEffect } from "react";
import {
  Navbar,
  Nav,
  Container,
  Row,
  Col,
  Card,
  Button,
  ListGroup,
  Form,
} from "react-bootstrap";
import Dropdown from "react-bootstrap/Dropdown";
import { useLocation, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { List } from "react-bootstrap-icons";
import "../style/admin.css";
import Spinner from "react-bootstrap/Spinner";
import axios, { all } from "axios";
import { GrCart } from "react-icons/gr";
import Modal from "react-bootstrap/Modal";
import Offcanvas from "react-bootstrap/Offcanvas";
import { RxCross1, RxHamburgerMenu } from "react-icons/rx";
import { useContext } from "react";
import { CartContext } from "./CartContext";
import { apibasePath } from "../config";
const SlideBar = () => {
  const [cart, setCart] = useState([]);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [displayData, setDisplayData] = useState([]);
  const [itemCode, setItemCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [allData, setAllData] = useState([]);
  const [selectedItem, setSelectedItem] = useState("Products");
  const [show, setShow] = useState(false);
  const [showSidebar, setShowSidebar] = useState(false);
  const [brandLogo, setBrandLogo] = useState(null);

  // const [cartCount, setCartCount] = useState(0);

  const [AllSizes, setAllSizes] = useState([]);
  // const [maxSizes, setMaxSizes] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [apiData, setApiData] = useState(null);
  const [error, setError] = useState(null);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [count, setcount] = useState(0);
  const [logo, setLogo] = useState(null);
  const [name, setName] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [sizes, setSizes] = useState([]);

  const [selectProduct, setSelectProduct] = useState(false);

  const Token = localStorage.getItem("token");

  const navigate = useNavigate();

  useEffect(() => {
    fetchData();
    // handleAllitem();
    fetchdatas();
  }, []);

  // customer name

  const customerApi = `${apibasePath}/client/customer-name/`;

  const { cartCount } = useContext(CartContext);

  const fetchCustomerName = async () => {
    const Token = localStorage.getItem("token");

    try {
      let response = await axios.get(customerApi, {
        headers: {
          Authorization: `bearer ${Token}`,
          "Content-Type": "application/json",
        },
      });
      console.log("Customer API Response:", response.data);

      if (response.data?.name) {
        setCustomerName(response.data.name); // Set name only if it exists
      } else {
        console.warn("Customer name not found in API response");
      }
    } catch (error) {
      console.error("Error fetching customer name:", error);
    }
  };

  useEffect(() => {
    fetchCustomerName(); // Call function inside useEffect
  }, []);
  // const addToCart = (product) => {
  //     setCart([...cart, product]);
  // };

  const handleClick = (item) => {
    // if (item === "Products") {
    //     handleAllitem();
    // } else {
    // fetchItemData(item);
    // }
    fetchItemData(item);
    setSelectedItem(item === "Products" ? "Products" : item.item_name);
  };

  const All_Api = `${apibasePath}/client/customer-item-stock-list/`;

  const handleAllitem = async () => {
    // const Token = localStorage.getItem("token");
    <h1>Select Product</h1>;
    try {
      setLoading(true);
      const res = await axios.get(All_Api, {
        headers: {
          Authorization: `bearer ${Token}`,
          "Content-Type": "application/json",
        },
      });
      setSelectedItem("Products");
      setDisplayData(res.data);
      setLoading(false);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchItemData = async (item) => {
    const Token = localStorage.getItem("token");

    setItemCode(item.item_code);

    try {
      // setLoading(true);
      const res = await axios.get(
        `${apibasePath}/client/customer-item-stock/${item.item_code}/`,
        {
          headers: {
            Authorization: `bearer ${Token}`,
            "Content-Type": "application/json",
          },
        },
      );

      setDisplayData(res?.data);
      setSelectProduct(true);
      // setLoading(false);
    } catch (error) {
      console.error("Error while getting data", error);
      // setLoading(false);
    }
  };

  const [filters, setFilters] = useState({
    gross_weight_min: "",
    gross_weight_max: "",
    net_weight_min: "",
    net_weight_max: "",
    stone_weight_min: "",
    stone_weight_max: "",
    size_min: "",
    size_max: "",
  });

  const [selectedSizes, setSelectedSizes] = useState([]);
  const [data, setData] = useState([]);
  // useEffect(() => {
  //   const storedFilters = localStorage.getItem("filters");
  //   const storedSelectedItem = localStorage.getItem("selectedItem");
  //   const storedAllSizes = localStorage.getItem("allSizes");
  //   const storedDisplayData = localStorage.getItem("displayData");
  //   const storedSelectProduct = localStorage.getItem("selectProduct");

  //   if (storedFilters) setFilters(JSON.parse(storedFilters));
  //   if (storedSelectedItem) setSelectedItem(JSON.parse(storedSelectedItem));
  //   if (storedAllSizes) setAllSizes(JSON.parse(storedAllSizes));
  //   if (storedDisplayData) setDisplayData(JSON.parse(storedDisplayData));
  //   if (storedSelectProduct) setSelectProduct(JSON.parse(storedSelectProduct));
  // }, []);

  // useEffect(() => {
  //   localStorage.setItem("filters", JSON.stringify(filters));
  //   localStorage.setItem("selectedItem", JSON.stringify(selectedItem));
  //   localStorage.setItem("allSizes", JSON.stringify(AllSizes));
  //   localStorage.setItem("displayData", JSON.stringify(displayData));
  //   localStorage.setItem("selectProduct", JSON.stringify(selectProduct));
  // }, [filters, selectedItem, AllSizes, displayData, selectProduct]);

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const gross_weight_min = searchParams.get("gross_weight_min") || "";
    const gross_weight_max = searchParams.get("gross_weight_max") || "";
    const net_weight_min = searchParams.get("net_weight_min") || "";
    const net_weight_max = searchParams.get("net_weight_max") || "";
    const stone_weight_min = searchParams.get("stone_weight_min") || "";
    const stone_weight_max = searchParams.get("stone_weight_max") || "";
    const size_min = searchParams.get("stone_weight_max") || "";
    const size_max = searchParams.get("stone_weight_max") || "";
    setFilters({
      gross_weight_min,
      gross_weight_max,
      net_weight_min,
      net_weight_max,
      stone_weight_min,
      stone_weight_max,
      size_min,
      size_max,
    });
  }, []);

  useEffect(() => {
    fetchDataFilters(filters);
    updateHistory(filters);
  }, [filters]);

  const fetchDataFilters = async (filterParams) => {
    const fetchedData = await applyFilters(filterParams);
    setData(fetchedData);
    if (filterParams.gross_weight_min) {
      applyFilters = applyFilters.filter(
        (item) => item.category === filterParams.gross_weight_min,
      );
    }
    if (filterParams.gross_weight_max) {
      applyFilters = applyFilters.filter(
        (item) => item.category === filterParams.gross_weight_max,
      );
    }
    if (filterParams.net_weight_min) {
      applyFilters = applyFilters.filter(
        (item) => item.category === filterParams.net_weight_min,
      );
    }

    if (filterParams.net_weight_max) {
      applyFilters = applyFilters.filter(
        (item) => item.category === filterParams.net_weight_max,
      );
    }
    if (filterParams.stone_weight_min) {
      applyFilters = applyFilters.filter(
        (item) => item.category === filterParams.stone_weight_min,
      );
    }
    if (filterParams.stone_weight_max) {
      applyFilters = applyFilters.filter(
        (item) => item.category === filterParams.stone_weight_max,
      );
    }

    if (filterParams.size_weight_min) {
      applyFilters = applyFilters.filter(
        (item) => item.category === filterParams.size_weight_min,
      );
    }

    if (filterParams.size_weight_max) {
      applyFilters = applyFilters.filter(
        (item) => item.category === filterParams.size_weight_max,
      );
    }
  };

  useEffect(() => {
    const handlePopstate = (event) => {
      if (event.state) {
        setFilters(event.state);
        fetchData(event.state);
      }
    };

    window.addEventListener("popstate", handlePopstate);
    return () => window.removeEventListener("popstate", handlePopstate);
  }, []);

  const updateHistory = (newFilters) => {
    const params = new URLSearchParams();
    if (newFilters.gross_weight_min)
      params.set("gross_weight_min", newFilters.gross_weight_min);
    if (newFilters.gross_weight_max)
      params.set("gross_weight_max", newFilters.gross_weight_max);
    if (newFilters.net_weight_min)
      params.set("net_weight_min", newFilters.net_weight_min);
    if (newFilters.net_weight_max)
      params.set("net_weight_max", newFilters.net_weight_max);
    if (newFilters.stone_weight_min)
      params.set("stone_weight_min", newFilters.stone_weight_min);
    if (newFilters.stone_weight_max)
      params.set("stone_weight_max", newFilters.stone_weight_max);
    if (newFilters.size_weight_min)
      params.set("size_weight_min", newFilters.size_weight_min);
    if (newFilters.size_weight_max)
      params.set("size_weight_max", newFilters.size_weight_max);
    // Avoid pushing same state again
    const currentParams = window.location.search;
    const newParams = `?${params.toString()}`;
    if (currentParams !== newParams) {
      window.history.pushState(newFilters, "", newParams);
    }
  };

  const location = useLocation();

  // useEffect(() => {
  //     if (location.pathname === '/mydesigns') {
  //     //   localStorage.removeItem('')
  //     localStorage.removeItem("filters");
  //     localStorage.removeItem("selectedItem");
  //     localStorage.removeItem("allSizes");
  //     localStorage.removeItem("displayData");
  //     localStorage.removeItem("selectProduct");

  //     console.log('deleted sucessfully');

  //     }
  //   }, [filters,selectedItem,AllSizes,displayData,selectProduct]);

  const applyFilters = async (filterParams) => {
    const Token = localStorage.getItem("token");

    try {
      const queryParams = new URLSearchParams();

      // Add checkbox filters
      if (AllSizes.length > 0) {
        queryParams.append("size", AllSizes.join(","));
      }

      Object.entries(filters).forEach(([key, value]) => {
        if (value !== "") {
          queryParams.append(key, value);
        }
      });

      const url = `${apibasePath}/client/customer-item-stock-list/?${queryParams.toString()}`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `bearer ${Token}`,
          "Content-Type": "application/json",
        },
      });
      console.log("fyxgsfhdashcs", response);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log(data, "data");

      setDisplayData(data);
    } catch (error) {
      console.error("Error while fetching data", error);
    } finally {
      // setLoading(false);
    }
  };

  const [selectedData, setSelectedData] = useState([]);

  //     const cleared = {
  //         gross_weight_min: "",
  //         gross_weight_max: "",
  //         net_weight_min: "",
  //         net_weight_max: "",
  //         stone_weight_min: "",
  //         stone_weight_max: "",
  //         size: ""
  //       };

  //       setFilters(cleared);
  //       setAllSizes([]);

  //       localStorage.removeItem('selectedSizes');
  //       Object.keys(cleared).forEach(key => {
  //         localStorage.removeItem(key);
  //       });

  //       setSelectedData([]);

  //       document.querySelectorAll('input[type=checkbox]').forEach(el => el.checked = false);

  //       // 6. Show all items again
  //     //   handleAllitem();

  //         };

  const clearFilters = () => {
    const cleared = {
      gross_weight_min: "",
      gross_weight_max: "",
      net_weight_min: "",
      net_weight_max: "",
      stone_weight_min: "",
      stone_weight_max: "",
      size: "",
    };

    setFilters(cleared);
    setAllSizes([]);
    setSelectedData([]);

    localStorage.removeItem("selectedSizes");
    Object.keys(cleared).forEach((key) => {
      localStorage.removeItem(key);
    });

    // Clear input fields directly if they exist in the DOM
    document.querySelectorAll('input[type="number"]').forEach((input) => {
      if (
        input.name === "gross_weight_min" ||
        input.name === "gross_weight_max" ||
        input.name === "net_weight_min" ||
        input.name === "net_weight_max" ||
        input.name === "stone_weight_min" ||
        input.name === "stone_weight_max"
      ) {
        input.value = "";
      }
    });

    document
      .querySelectorAll("input[type=checkbox]")
      .forEach((el) => (el.checked = false));

    const sizeInput = document.querySelector('input[name="size"]');
    if (sizeInput) {
      sizeInput.value = "";
    }

    //    fetchItemData()
    // If you have some handle function to re-render all item, call it here.
    // handleAllitem(); // uncomment if needed.
  };

  const handleInputChange = (e) => {
    const { name, value, key } = e.target;
    setFilters((prevFilters) => ({ ...prevFilters, [name]: value }));
    setFilters((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleCheckBoxChange = (event) => {
    const { name, checked, value } = event.target;

    if (name === "size") {
      setAllSizes(
        checked ? [value] : AllSizes.filter((size) => size !== value),
      ); // Modify this line
    }
  };

  const sizeApi = `${apibasePath}/client/available-sizes/`;

  useEffect(() => {
    const fetchSizeData = async () => {
      try {
        const response = await axios.get(sizeApi, {
          headers: {
            Authorization: `bearer ${Token}`,
            "Content-Type": "application/json",
          },
        });
        console.log(response);
        setSizes(response.data); // Assuming response.data is an array of size values
      } catch (error) {
        console.error("Error fetching sizes:", error);
      }
    };

    fetchSizeData();
  }, []);

  const API_URL = `${apibasePath}/client/cart/add/`;

  const { cartItems, setCartItems } = useContext(CartContext);

  const handleAddToCart = async (product) => {
    const Token = localStorage.getItem("token");
    try {
      const response = await axios.post(API_URL, product, {
        headers: {
          Authorization: `bearer ${Token}`,
          "Content-Type": "application/json",
        },
      });

      const newCart = [...cartItems, product.item_tag];
      setCartItems(newCart);
      console.log("button cart list", cartItems);
      setLoading(false);
    } catch (error) {
      console.error("Error adding to cart", error);
      if (error.response?.status === 400) {
        if (!cartItems.includes(product.item_tag)) {
          setCartItems([...cartItems, product.item_tag]);
        }
      } else {
        alert("An error occurred while adding to cart.");
      }
    }
  };

  const Api_Url = `${apibasePath}/client/customer-items/`;

  const [itemData, setItemData] = useState([]);

  const fetchData = async () => {
    const Token = localStorage.getItem("token");

    try {
      setLoading(true);
      const res = await axios.get(Api_Url, {
        headers: {
          Authorization: `bearer ${Token}`,
        },
      });
      setItemData(res.data);
      setLoading(false);
    } catch (error) {
      console.error("error", error);
    }
  };

  if (loading) {
    return (
      <div
        style={{
          top: "50%",
          left: "50%",
          translate: ("-50%", "-50%"),
          position: "absolute",
        }}
        className="slide"
      >
        <Spinner animation="border" role="status" variant="primary">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
  }

  const Api_url = `${apibasePath}/client/profiles/company/`;

  const fetchdatas = async () => {
    try {
      const response = await axios.get(Api_url, {
        headers: { "Content-Type": "application/json" },
      });
      setLogo(response.data.logo);
      setName(response.data.name);
    } catch (error) {
      console.error("Error fetching company details:", error);
    }
  };

  const handleSidebarClose = () => setShowSidebar(false);
  const handleSidebarShow = () => setShowSidebar(true);

  const ClearFilters = () => {};

  return (
    <div className="slide">
      <Navbar className="bg-body-tertiary fixed-top" expand="md">
        <Container fluid>
          <Navbar.Brand>
            <div
              style={{
                width: "100px",
                height: "50px",
                borderRadius: "10px",
                overflow: "hidden",
              }}
            >
              <img
                src={logo}
                alt="companylogo"
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            </div>
          </Navbar.Brand>
          <Navbar.Brand
            style={{
              color: "#23395B",
              fontFamily: "Roboto",
              fontWeight: "600",
              marginRight: "auto",
              fontSize: "17px",
            }}
          >
            {name}
          </Navbar.Brand>
          <Navbar.Brand
            style={{
              color: "#23395B",
              fontFamily: "Roboto",
              fontWeight: "600",
              marginRight: "auto",
              fontSize: "17px",
            }}
          >
            {customerName}'s Shopping Cart
          </Navbar.Brand>
          <div className="d-flex align-items-center">
            <Button
              variant="outline-light"
              className="d-md-none"
              onClick={handleSidebarShow}
            >
              <RxHamburgerMenu
                style={{
                  width: "30px",
                  height: "30px",
                  cursor: "pointer",
                  color: "#000",
                }}
              />
            </Button>
            <Navbar.Brand className="cart">
              {/* <a href="/add-to-cartdetails">
                                <GrCart style={{ width: '30px', height: '30px', color: '#396D72' }} />
                            </a> */}
              <a href="/add-to-cartdetails" style={{ position: "relative" }}>
                <GrCart
                  style={{ width: "30px", height: "30px", color: "#396D72" }}
                />
                {cartCount > 0 && (
                  <span
                    style={{
                      position: "absolute",
                      top: "-5px",
                      right: "-5px",
                      backgroundColor: "red",
                      color: "white",
                      borderRadius: "50%",
                      padding: "4px 7px",
                      fontSize: "12px",
                    }}
                  >
                    {cartCount}
                  </span>
                )}
              </a>
            </Navbar.Brand>
          </div>
        </Container>
      </Navbar>

      <Container fluid>
        <Row>
          {/* Sidebar - Always visible on larger screens, collapsible on mobile */}

          <Col
            md={3}
            className="p-3 d-none d-md-block fixed-sidebar "
            style={{
              backgroundColor: "#396D72",
              height: "130vh",
              marginTop: "70px",
            }}
          >
            {/* <h5 className="text-white">Jewellery Items</h5> */}
            <Dropdown>
              <Dropdown.Toggle
                variant=""
                style={{
                  color: "#fff",
                  border: "none",
                  fontSize: "20px",
                  fontfamily: "Roboto",
                  fontWeight: "500",
                  lineHeight: "1.2",
                  letterSpacing: "0",
                  marginLeft: "22px",
                }}
              >
                {selectedItem}
              </Dropdown.Toggle>
              <Dropdown.Menu
                style={{
                  backgroundImage:
                    "linear-gradient(to bottom left,#C7E0E3, #FFFFFF ) ",
                }}
              >
                {/* <Dropdown.Item  key="all" >Products</Dropdown.Item> */}
                {itemData.map((item, index) => (
                  <Dropdown.Item key={index} onClick={() => handleClick(item)}>
                    {item.item_name}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>

            {/* filters */}

            <div>
              <Form style={{ paddingTop: "20px", marginLeft: "30px" }}>
                {/* <Form.Label style={{ color: '#fff', fontSize: '30px', fontFamily: 'Poppins', textDecoration: "underline" }}>Apply Filters</Form.Label> */}
                <Form.Group>
                  <Form.Label
                    style={{
                      color: "#fff",
                      fontfamily: "Roboto",
                      fontWeight: "500",
                      lineHeight: "1.2",
                      letterSpacing: "0",
                      fontSize: "20px",
                    }}
                  >
                    Size
                  </Form.Label>{" "}
                  <br />
                  <div
                    className="checks"
                    style={{
                      display: "flex",
                      color: "#fff",
                      justifyContent: "space-between",
                      backgroundColor: "transparent",
                    }}
                  >
                    <div>
                      {sizes.map((size, index) => (
                        <Form.Check
                          key={index}
                          type="checkbox"
                          onChange={handleCheckBoxChange}
                          name="size"
                          value={size}
                          label={size}
                          className="mb-2 transparent-checkbox"
                        />
                      ))}
                    </div>
                  </div>
                </Form.Group>

                {/* Gross Weight */}
                <Form.Group style={{ paddingTop: "10px", marginTop: "20px" }}>
                  <Form.Label
                    style={{
                      color: "#fff",
                      fontfamily: "Roboto",
                      fontWeight: "500",
                      lineHeight: "1.2",
                      letterSpacing: "0",
                      fontSize: "20px",
                    }}
                  >
                    Gross Weight
                  </Form.Label>
                  <div style={{ display: "flex" }}>
                    <Form.Control
                      type="number"
                      style={{
                        backgroundColor: "transparent",
                        color: "#fff",
                        borderRadius: "3px",
                      }}
                      name="gross_weight_min"
                      placeholder="Min"
                      onChange={handleInputChange}
                    />
                    <Form.Control
                      type="number"
                      name="gross_weight_max"
                      placeholder="Max"
                      onChange={handleInputChange}
                      style={{
                        marginLeft: "10px",
                        backgroundColor: "transparent",
                        color: "#fff",
                        borderRadius: "3px",
                      }}
                    />
                  </div>
                </Form.Group>

                {/* Net Weight */}
                <Form.Group style={{ paddingTop: "10px", marginTop: "20px" }}>
                  <Form.Label
                    style={{
                      color: "#fff",
                      fontfamily: "Roboto",
                      fontWeight: "500",
                      lineHeight: "1.2",
                      letterSpacing: "0",
                      fontSize: "20px",
                    }}
                  >
                    Net Weight
                  </Form.Label>
                  <div style={{ display: "flex", marginTop: "3px" }}>
                    <Form.Control
                      type="number"
                      style={{
                        backgroundColor: "transparent",
                        color: "#fff",
                        borderRadius: "3px",
                      }}
                      name="net_weight_min"
                      placeholder="Min"
                      onChange={handleInputChange}
                    />
                    <Form.Control
                      type="number"
                      name="net_weight_max"
                      placeholder="Max"
                      onChange={handleInputChange}
                      style={{
                        marginLeft: "10px",
                        backgroundColor: "transparent",
                        color: "#fff",
                        borderRadius: "3px",
                      }}
                    />
                  </div>
                </Form.Group>

                {/* Stone Weight */}
                <Form.Group style={{ paddingTop: "10px", marginTop: "20px" }}>
                  <Form.Label
                    style={{
                      color: "#fff",
                      fontfamily: "Roboto",
                      fontWeight: "500",
                      lineHeight: "1.2",
                      letterSpacing: "0",
                      fontSize: "20px",
                    }}
                  >
                    Stone Weight
                  </Form.Label>
                  <div style={{ display: "flex" }}>
                    <Form.Control
                      type="number"
                      style={{
                        backgroundColor: "transparent",
                        color: "#fff",
                        borderRadius: "3px",
                      }}
                      name="stone_weight_min"
                      placeholder="Min"
                      onChange={handleInputChange}
                    />
                    <Form.Control
                      type="number"
                      name="stone_weight_max"
                      placeholder="Max"
                      onChange={handleInputChange}
                      style={{
                        marginLeft: "10px",
                        backgroundColor: "transparent",
                        color: "#fff",
                        borderRadius: "3px",
                      }}
                    />
                  </div>
                </Form.Group>

                {/* Apply Filters Button */}
                <div
                  align="center"
                  className="apply_button"
                  style={{ marginTop: "50px" }}
                >
                  <Button
                    style={{
                      backgroundColor: "#fff",
                      color: "#23395B",
                      boxShadow: "0px 0px 7px 0px #000",
                      border: "none",
                    }}
                    className="pe-4 ps-4 mt-4 me-4"
                    variant="light"
                    onClick={applyFilters}
                  >
                    Apply Filters
                  </Button>
                  <Button
                    style={{
                      backgroundColor: "#fff",
                      color: "#23395B",
                      boxShadow: "0px 0px 7px 0px #000",
                      border: "none",
                    }}
                    className="pe-4 ps-4 mt-4 me-4"
                    variant="light"
                    onClick={clearFilters}
                  >
                    Clear Filters
                  </Button>
                  {/* <Button style={{ backgroundColor: '#fff', color: '#23395B', boxShadow: '0px 0px 7px 0px #000', border: 'none' }} className="pe-4 ps-4 mt-4 me-4" variant="light" onClick={ClearFilters}>clear Filters</Button> */}
                </div>
              </Form>
            </div>
          </Col>

          {/* Offcanvas Sidebar for Mobile */}
          <Offcanvas
            show={showSidebar}
            onHide={handleSidebarClose}
            placement="start"
          >
            <Offcanvas.Header
              className="custom-offcanvas-header"
              variant="light"
              closeButton
              style={{ backgroundColor: "#396D72", color: "#fff" }}
            >
              <Offcanvas.Title>Menu</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body style={{ backgroundColor: "#396D72" }}>
              <Dropdown>
                <Dropdown.Toggle
                  variant=""
                  style={{ color: "#fff", border: "none", fontSize: "20px" }}
                >
                  {selectedItem}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {/* <Dropdown.Item onClick={() => handleClick("All")} key="all">All Products</Dropdown.Item> */}
                  {itemData.map((item, index) => (
                    <Dropdown.Item
                      key={index}
                      onClick={() => handleClick(item)}
                    >
                      {item.item_name}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>

              <div align="end">
                <Navbar.Brand className="">
                  <a href="/add-to-cartdetails">
                    <GrCart
                      style={{ width: "33px ", height: "31px", color: "#fff" }}
                    />
                  </a>
                </Navbar.Brand>
              </div>

              {/* filters */}
              <div>
                <Form style={{ paddingTop: "20px" }}>
                  {/* <Form.Label style={{ color: '#fff', fontSize: '30px', fontFamily: 'Poppins', textDecoration: "underline" }}>Apply Filters</Form.Label> */}
                  <Form.Group>
                    <Form.Label
                      style={{
                        color: "#fff",
                        fontfamily: "Roboto",
                        fontWeight: "500",
                        lineHeight: "1.2",
                        letterSpacing: "0",
                        fontSize: "20px",
                      }}
                    >
                      Size
                    </Form.Label>{" "}
                    <br />
                    <div
                      className="checks"
                      style={{
                        display: "flex",
                        color: "#fff",
                        justifyContent: "space-between",
                        backgroundColor: "transparent",
                      }}
                    >
                      <div>
                        {sizes.map((size, index) => (
                          <Form.Check
                            key={index}
                            type="checkbox"
                            onChange={handleCheckBoxChange}
                            name="size_min"
                            value={size}
                            label={size}
                            className="mb-2 transparent-checkbox"
                          />
                        ))}
                      </div>
                      <div style={{ marginRight: "80px" }}>
                        {sizes.map((size, index) => (
                          <Form.Check
                            key={`max-${index}`}
                            type="checkbox"
                            onChange={handleCheckBoxChange}
                            name="size_max"
                            value={size}
                            label={size}
                            className="mb-2 transparent-checkbox"
                          />
                        ))}
                      </div>
                    </div>
                  </Form.Group>
                  {/* Gross Weight */}
                  <Form.Group style={{ paddingTop: "10px" }}>
                    <Form.Label
                      style={{
                        color: "white",
                        fontSize: "20px",
                        fontFamily: "Poppins",
                      }}
                    >
                      Gross Weight
                    </Form.Label>
                    <div style={{ display: "flex" }}>
                      <Form.Control
                        style={{
                          backgroundColor: "transparent",
                          color: "#fff",
                        }}
                        type="number"
                        name="gross_weight_min"
                        placeholder="Min"
                        onChange={handleInputChange}
                      />
                      <Form.Control
                        type="number"
                        name="gross_weight_max"
                        placeholder="Max"
                        onChange={handleInputChange}
                        style={{
                          marginLeft: "10px",
                          backgroundColor: "transparent",
                          color: "#fff",
                        }}
                      />
                    </div>
                  </Form.Group>

                  {/* Net Weight */}
                  <Form.Group style={{ paddingTop: "10px" }}>
                    <Form.Label
                      style={{
                        color: "white",
                        fontSize: "20px",
                        fontFamily: "Poppins",
                      }}
                    >
                      Net Weight
                    </Form.Label>
                    <div style={{ display: "flex" }}>
                      <Form.Control
                        style={{
                          backgroundColor: "transparent",
                          color: "#fff",
                        }}
                        type="number"
                        name="net_weight_min"
                        placeholder="Min"
                        onChange={handleInputChange}
                      />
                      <Form.Control
                        type="number"
                        name="net_weight_max"
                        placeholder="Max"
                        onChange={handleInputChange}
                        style={{
                          marginLeft: "10px",
                          backgroundColor: "transparent",
                          color: "#fff",
                        }}
                      />
                    </div>
                  </Form.Group>

                  {/* Stone Weight */}
                  <Form.Group style={{ paddingTop: "10px" }}>
                    <Form.Label
                      style={{
                        color: "white",
                        fontSize: "20px",
                        fontFamily: "Poppins",
                      }}
                    >
                      Stone Weight
                    </Form.Label>
                    <div style={{ display: "flex" }}>
                      <Form.Control
                        type="number"
                        style={{
                          backgroundColor: "transparent",
                          color: "#fff",
                        }}
                        name="stone_weight_min"
                        placeholder="Min"
                        onChange={handleInputChange}
                      />
                      <Form.Control
                        type="number"
                        name="stone_weight_max"
                        placeholder="Max"
                        onChange={handleInputChange}
                        style={{
                          marginLeft: "10px",
                          backgroundColor: "transparent",
                          color: "#fff",
                        }}
                      />
                    </div>
                  </Form.Group>

                  {/* Apply Filters Button */}
                  <div
                    align="center"
                    style={{ marginTop: "50px" }}
                    className=""
                  >
                    <Button
                      style={{
                        backgroundColor: "#fff",
                        color: "#23395B",
                        boxShadow: "0px 0px 7px 0px #000",
                        border: "none",
                      }}
                      className="pe-4 ps-4 mt-4 me-4"
                      variant=""
                      onClick={applyFilters}
                    >
                      Apply Filters
                    </Button>
                    <Button
                      style={{
                        backgroundColor: "#fff",
                        color: "#23395B",
                        boxShadow: "0px 0px 7px 0px #000",
                        border: "none",
                      }}
                      className="pe-4 ps-4 mt-4 me-4"
                      variant="light"
                      onClick={clearFilters}
                    >
                      Clear Filters
                    </Button>
                  </div>
                </Form>
              </div>
            </Offcanvas.Body>
          </Offcanvas>

          {/* //product items */}

          <Col
            md={9}
            className="scrollable-content"
            style={{ marginTop: "70px" }}
          >
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "space-evenly",
                marginTop: "10px",
                gap: "10px",
              }}
            >
              {selectProduct ? (
                displayData && displayData.length > 0 ? (
                  displayData.map((product) => (
                    <Card
                      style={{
                        width: "18rem",
                        height: "30rem",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        borderRadius: "15px",
                      }}
                    >
                      <div
                        style={{
                          width: "100%",
                          height: "100%",
                          overflow: "hidden",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <img
                          onClick={() =>
                            navigate(`/customer-items/${product.id}`)
                          }
                          variant="top"
                          src={
                            product.image
                              ? product.image
                              : "./images/noimage.jpg"
                          }
                          style={{
                            width: "100%",
                            height: "100%",
                            // backgroundSize: 'contain',
                            borderTopLeftRadius: "10px",
                            borderTopRightRadius: "10px",
                            objectFit: "cover",
                          }}
                        />
                      </div>

                      <Card.Body
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-between",
                          flexGrow: 1,
                        }}
                      >
                        <div align="center">
                          <p
                            style={{
                              fontFamily: "Roboto",
                              fontWeight: "600",
                              fontSize: "18px",
                              lineHeight: "0",
                              letterSpacing: "0",
                            }}
                          >
                            {product.item_tag}
                          </p>
                          <p
                            style={{
                              fontFamily: "Roboto",
                              fontWeight: "600",
                              fontSize: "18px",
                              lineHeight: "1",
                              letterSpacing: "0",
                            }}
                          >
                            {product.item_name}
                          </p>
                        </div>
                        <Card.Text
                          style={{ marginTop: "10px", marginLeft: "25%" }}
                        >
                          <p
                            style={{
                              lineHeight: "0.5",
                              fontFamily: "Roboto",
                              fontWeight: "400",
                            }}
                          >
                            Gross Wt&nbsp; : {product.gross_weight} gm
                          </p>
                          <p
                            style={{
                              lineHeight: "0.5",
                              fontFamily: "Roboto",
                              fontWeight: "400",
                            }}
                          >
                            Net Wt&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; :{" "}
                            {product.net_weight} gm
                          </p>
                          <p
                            style={{
                              lineHeight: "0.5",
                              fontFamily: "Roboto",
                              fontWeight: "400",
                            }}
                          >
                            Stone Wt&nbsp; : {product.stone_weight} gm
                          </p>
                          <p
                            style={{
                              lineHeight: "0.5",
                              fontFamily: "Roboto",
                              fontWeight: "400",
                            }}
                          >
                            Size&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:{" "}
                            {product.size}{" "}
                          </p>
                        </Card.Text>
                      </Card.Body>
                      <Button
                        variant="primary"
                        className="w-100 mt-2"
                        style={{
                          backgroundColor: cartItems.includes(product.item_tag)
                            ? "#396D72"
                            : "#D1B457",
                          // backgroundColor:'#D1B457',
                          border: "none",
                          borderBottomLeftRadius: "13px",
                          borderBottomRightRadius: "13px",
                          borderTopRightRadius: "0",
                          borderTopLeftRadius: "0",
                        }}
                        onClick={() => handleAddToCart(product)}
                        disabled={cartItems.includes(product.item_tag)}
                      >
                        {cartItems.includes(product.item_tag)
                          ? "Added to Cart"
                          : "Add to Cart"}
                      </Button>
                    </Card>
                  ))
                ) : (
                  <Col className="text-centere">
                    <p
                      style={{
                        fontSize: "24px",
                        fontWeight: "bold",
                        alignItems: "center",
                      }}
                    >
                      No Item found
                    </p>
                  </Col>
                )
              ) : (
                <Col className="text-centere">
                  <p
                    style={{
                      fontSize: "24px",
                      fontWeight: "bold",
                      alignItems: "center",
                    }}
                  >
                    {" "}
                    Select Product
                  </p>
                </Col>
              )}
            </div>
          </Col>
        </Row>
      </Container>

      <hr style={{ border: "1px solid #000000" }} />

      <div
        className="address"
        style={{
          // marginLeft: "auto",
          // marginRight: "auto",
          marginTop: "30px",
          // borderTop: "1px solid",
          fontFamily: "Roboto",
          fontWeight: "500",
          maxWidth: "600px", // Limit the width for better readability on larger screens
          padding: "0 20px", // Add padding for smaller screens
        }}
      >
        <div>
          <h3
            style={{
              fontSize: "20px",
              fontFamily: "Roboto",
              fontWeight: "500",
              marginTop: "30px",
              lineHeight: "1",
              letterSpacing: "0",
            }}
          >
            Shubham Jewellers
          </h3>
        </div>
        <div>
          <h2
            style={{
              fontSize: "20px",
              fontFamily: "Roboto",
              fontWeight: "500",
              marginTop: "20px",
              lineHeight: "1",
              letterSpacing: "0",
            }}
          >
            Address
          </h2>
          <p
            style={{
              fontSize: "15px",
              fontFamily: "Roboto",
              fontWeight: "500",
              marginTop: "20px",
              lineHeight: "1",
              letterSpacing: "0",
            }}
          >
            Sri Shubham jewellery, 2 nd floor 201/202, mayur kushal complex
            abids, Gunfoundry, Hyderabad 500001, Telegana, India
          </p>
        </div>
        <div>
          <h2
            style={{
              fontSize: "20px",
              fontFamily: "Roboto",
              fontWeight: "500",
              lineHeight: "1",
              letterSpacing: "0",
            }}
          >
            Phone
          </h2>
          <p
            style={{
              fontSize: "15px",
              fontFamily: "Roboto",
              fontWeight: "500",
              marginTop: "20px",
              lineHeight: "1",
              letterSpacing: "0",
            }}
          >
            +919949946000
          </p>
        </div>
        <div>
          <h2
            style={{
              fontSize: "20px",
              fontFamily: "Roboto",
              fontWeight: "500",
              lineHeight: "1",
              letterSpacing: "0",
            }}
          >
            Email
          </h2>
          <p
            style={{
              fontSize: "15px",
              fontFamily: "Roboto",
              fontWeight: "500",
              marginTop: "20px",
              lineHeight: "1",
              letterSpacing: "0",
            }}
          >
            srishubhamjewellers@gmail.com
          </p>
        </div>
      </div>
      <div align="center" style={{ fontFamily: "Roboto", marginTop: "30px" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexWrap: "wrap",
          }}
        >
          <h4
            align="center"
            style={{ fontSize: "14px", marginTop: "31px", color: "#35646E" }}
          >
            POWERED BY
          </h4>
          <div
            style={{
              width: "100px",
              height: "50px",
              borderRadius: "10px",
              overflow: "hidden",
              alignItems: "center",
              justifyContent: "center",
              marginLeft: "5px", //add some space between text and logo
            }}
          >
            <img
              src={brandLogo}
              alt="Brandlogo"
              style={{ width: "100%", height: "100%", backgroundSize: "cover" }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SlideBar;
